var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarehouseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.98 17.0803L28.98 6.42027C26.14 3.90027 21.86 3.90027 19.02 6.42027L7.02 17.0803C5.42 18.5003 4.5 20.5403 4.5 22.6803V35.9803C4.5 40.1203 7.86 43.4803 12 43.4803H36C40.14 43.4803 43.5 40.1203 43.5 35.9803V22.6803C43.5 20.5403 42.58 18.5003 40.98 17.0803ZM32.5 40.5003H15.5V28.0003C15.5 26.6203 16.62 25.5003 18 25.5003H30C31.38 25.5003 32.5 26.6203 32.5 28.0003V40.5003ZM40.5 36.0003C40.5 38.4803 38.48 40.5003 36 40.5003H35.5V28.0003C35.5 24.9603 33.04 22.5003 30 22.5003H18C14.96 22.5003 12.5 24.9603 12.5 28.0003V40.5003H12C9.52 40.5003 7.5 38.4803 7.5 36.0003V22.7003C7.5 21.4203 8.06 20.1803 9 19.3403L21 8.68027C21.86 7.92027 22.92 7.54027 24 7.54027C25.08 7.54027 26.14 7.92027 27 8.68027L39 19.3403C39.96 20.2003 40.5 21.4203 40.5 22.7003V36.0003Z",
    fill: "#2A364E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.5H20C19.18 16.5 18.5 17.18 18.5 18C18.5 18.82 19.18 19.5 20 19.5H28C28.82 19.5 29.5 18.82 29.5 18C29.5 17.18 28.82 16.5 28 16.5Z",
    fill: "#2A364E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseIcon);
export default __webpack_public_path__ + "static/media/warehouseIcon.ba348c2055e38903894147859869491f.svg";
export { ForwardRef as ReactComponent };